
import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Cpu, CheckCircle, Globe, Search, ArrowRight } from 'lucide-react';
// Fix: Import missing Badge component and cn utility
import { Badge } from './UI';
import { cn } from '../lib/utils';

export const AgentNetwork = () => {
  return (
    <div className="absolute inset-0 pointer-events-none opacity-20 overflow-hidden">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f59e0b" stopOpacity="0" />
            <stop offset="50%" stopColor="#f59e0b" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#f59e0b" stopOpacity="0" />
          </linearGradient>
        </defs>
        {/* Mock connections */}
        {[...Array(12)].map((_, i) => (
          <motion.line
            key={i}
            x1={`${Math.random() * 100}%`}
            y1={`${Math.random() * 100}%`}
            x2={`${Math.random() * 100}%`}
            y2={`${Math.random() * 100}%`}
            stroke="url(#lineGrad)"
            strokeWidth="1"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: [0, 0.5, 0] }}
            transition={{ duration: 5 + Math.random() * 5, repeat: Infinity, ease: "linear" }}
          />
        ))}
      </svg>
    </div>
  );
};

export const LiveDemoCard = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="relative group"
    >
      <div className="absolute -inset-1 bg-accent/20 blur-2xl rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="relative glass p-6 rounded-3xl border border-white/10 w-full max-w-lg shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center text-accent">
              <FileText className="w-5 h-5" />
            </div>
            <div>
              <p className="text-xs font-bold text-white/40 uppercase tracking-widest">Input Stream</p>
              <p className="text-sm font-bold text-white">trade_finance_l_c.pdf</p>
            </div>
          </div>
          <Badge variant="accent">Processing</Badge>
        </div>

        <div className="space-y-4">
          <div className="p-4 rounded-2xl bg-white/5 border border-white/5 font-mono text-[11px] leading-relaxed">
            <p className="text-white/60 mb-2">EXTRACTED_ENTITY_MAP:</p>
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ staggerChildren: 0.1 }}
              className="space-y-1"
            >
              <div className="flex justify-between">
                <span className="text-accent">IBAN:</span>
                <span className="text-white/90">AE03200000...</span>
              </div>
              <div className="flex justify-between">
                <span className="text-accent">ISSUER:</span>
                <span className="text-white/90">Bank of Middle East</span>
              </div>
              <div className="flex justify-between">
                <span className="text-accent">LANGUAGE:</span>
                <span className="text-white/90">ARABIC (99.8% Conf)</span>
              </div>
            </motion.div>
          </div>

          <div className="flex items-center gap-2">
            <div className="flex-1 h-px bg-white/10" />
            <Cpu className="w-4 h-4 text-accent animate-pulse" />
            <div className="flex-1 h-px bg-white/10" />
          </div>

          <div className="space-y-2">
             <p className="text-xs font-bold text-white/40 uppercase tracking-widest">Agent Workflow</p>
             <div className="space-y-2">
               {[
                 { step: 'Observe', desc: 'Analyzing layout...', status: 'done' },
                 { step: 'Extract', desc: 'Fetching data points...', status: 'done' },
                 { step: 'Validate', desc: 'Checking AML DB...', status: 'active' },
               ].map((s, i) => (
                 <div key={i} className="flex items-center gap-3 text-xs">
                   <div className={cn(
                     "w-1.5 h-1.5 rounded-full",
                     s.status === 'done' ? "bg-green-500" : "bg-accent animate-pulse"
                   )} />
                   <span className="font-bold text-white/70 w-16">{s.step}</span>
                   <span className="text-white/40">{s.desc}</span>
                 </div>
               ))}
             </div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-white/10 flex justify-between items-center">
          <div className="flex -space-x-2">
            {[1, 2, 3].map(i => (
              <div key={i} className="w-6 h-6 rounded-full border border-deep-0 bg-deep-surface flex items-center justify-center text-[10px] font-bold text-white/60">
                A{i}
              </div>
            ))}
          </div>
          <button className="text-[11px] font-bold text-accent hover:underline flex items-center gap-1">
            Open Details <ArrowRight className="w-3 h-3" />
          </button>
        </div>
      </div>
    </motion.div>
  );
};
